const PAGE_TYPE = {
    H5: 1,
    PC: 10
};

/**
 * 使用页面类型参数
 * @return {object} { isPC: boolean, isH5: boolean, pageType: string }
 */
export function usePageType() {

    let route;
    if (window.FEGORender) {
        route = window.FEGORender.store.route;
    } else {
        route = window.FEGOEditor.app.project.route;
    }

    const isPC = route?.now.pageType === PAGE_TYPE.PC;
    const isH5 = !isPC;
    const pageType = isPC ? 'PC' : 'H5';

    return {
        isPC,
        isH5,
        pageType
    };
}
